var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBody(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 61,
    viewBox: "0 0 91 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.67033,
    y: 0.67033,
    width: 44.9121,
    height: 59.6593,
    stroke: "#7ABB5C",
    strokeWidth: 1.34066
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -0.67033,
    y: 0.67033,
    width: 44.6593,
    height: 59.6593,
    transform: "matrix(-1 0 0 1 89.6593 0)",
    stroke: "#7ABB5C",
    strokeWidth: 1.34066
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9641 8.80924L22.8313 8.22949L21.5245 8.52877L21.7031 9.30836L12.4727 53.1531L13.7846 53.4293L22.4169 12.4254L31.5795 52.4354L32.8863 52.1361L23.0756 9.29626L23.1691 8.85239L22.9641 8.80924Z",
    fill: "#7ABB5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.2822 8.8083L68.4124 8.2334L69.7179 8.52482L69.5413 9.30464L78.6719 53.1546L77.3594 53.4279L68.8278 12.4547L59.7728 52.4314L58.4673 52.14L68.1708 9.29983L68.0774 8.85095L68.2822 8.8083Z",
    fill: "#7ABB5C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9829 30.2972L39.2832 30.2121L39.1354 29.6905L39.2639 29.1795L38.9695 29.1055L38.9176 28.9222L38.5993 29.0124L8.59987 21.4707L8.27301 22.7709L36.0147 29.745L7.2482 37.8989L7.6138 39.1888L38.6201 30.4L38.937 30.4797L38.9829 30.2972Z",
    fill: "#7ABB5C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.447 30.301L52.1406 30.2132L52.2918 29.6906L52.1622 29.1805L52.4615 29.1044L52.5142 28.9223L52.8262 29.0117L82.4911 21.4717L82.8214 22.771L55.3843 29.7448L83.8375 37.899L83.464 39.1899L52.799 30.4019L52.4924 30.4798L52.447 30.301Z",
    fill: "#7ABB5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBody);
export default __webpack_public_path__ + "static/media/body.c80bcad47a8e5bcbc3748baf36d4188e.svg";
export { ForwardRef as ReactComponent };